import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import TrustBanner from './components/TrustBanner';
import StoryTeaser from './components/StoryTeaser';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <TrustBanner />
        <CategoryGrid />
        <StoryTeaser />
        {/* Final CTA */}
        <section className="py-20" style={{ backgroundColor: '#FAF7F2' }}>
          <div className="max-w-3xl mx-auto px-4 text-center">
            <p style={{ fontFamily: '"Dancing Script", cursive', color: '#C9933A', fontSize: '1.3rem' }} className="mb-2">Ready to find your magic?</p>
            <h2 style={{ fontFamily: '"Playfair Display", serif', color: '#4A3728' }} className="text-4xl md:text-5xl font-bold mb-6">
              Questions? We&apos;d Love to Hear From You
            </h2>
            <p style={{ fontFamily: '"Lato", sans-serif', color: '#7A5C42', lineHeight: 1.8 }} className="text-lg mb-10">
              Call us, email us, or send a message. We&apos;re real humans who genuinely love helping you find the perfect piece.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:7346468620"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-bold uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5"
                style={{ backgroundColor: '#1E4F4F', color: '#fff', fontFamily: '"Lato", sans-serif' }}
              >
                <i className="ri-phone-line"></i> Call Us
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-bold uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5"
                style={{ backgroundColor: '#C9933A', color: '#fff', fontFamily: '"Lato", sans-serif' }}
              >
                <i className="ri-mail-line"></i> Send a Message
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
